var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1653 1294.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a0e2a570-2ce9-4eb9-b0c6-29d1bdb09fd1,.a2fd895f-d03b-4a20-9916-1ec3d6481010,.a4753a2c-cb56-42e9-8e40-30df8551bb9e,.a9e28fa8-7fd5-48bd-8453-b7c400442eaf,.b30a17df-5083-4e10-8579-04c3a27d8be0,.b994df03-6474-481b-a395-8d457f773b18,.bfe7afad-bd5a-4943-bec3-64d3247c5ffe,.f6cddd5a-87d8-4287-a3ea-32b7ed0198c1,.fd94afec-1ba5-4319-998b-6c03797e77f3{fill:none;}.a47359d0-2193-4871-8304-9bd8721d890f{isolation:isolate;}.ae5cbfba-7d25-4345-92a6-7d275226ecc6{fill:#06756f;}.b956e935-0174-4c64-bce6-ab184e990bae{fill:#119390;}.a02a5973-6030-4987-bdf1-ad8922314aaa{opacity:0.2;}.abe8dd8d-644b-41e6-b164-f6ae009d519f{fill:#fff;}.f500324f-3e3e-4942-941a-72d0873443c2{fill:#ececec;}.fad0a59a-6131-4d99-ba87-fe17e858aca0{fill:#e1e1e1;}.a2fd895f-d03b-4a20-9916-1ec3d6481010,.b30a17df-5083-4e10-8579-04c3a27d8be0,.f6cddd5a-87d8-4287-a3ea-32b7ed0198c1,.fd94afec-1ba5-4319-998b-6c03797e77f3{stroke:#006a35;}.a2fd895f-d03b-4a20-9916-1ec3d6481010,.a4753a2c-cb56-42e9-8e40-30df8551bb9e,.a9e28fa8-7fd5-48bd-8453-b7c400442eaf,.b30a17df-5083-4e10-8579-04c3a27d8be0,.b994df03-6474-481b-a395-8d457f773b18,.bfe7afad-bd5a-4943-bec3-64d3247c5ffe,.f6cddd5a-87d8-4287-a3ea-32b7ed0198c1,.fd94afec-1ba5-4319-998b-6c03797e77f3{stroke-linecap:round;stroke-miterlimit:10;}.a9e28fa8-7fd5-48bd-8453-b7c400442eaf,.f6cddd5a-87d8-4287-a3ea-32b7ed0198c1{stroke-width:11.34px;}.a4753a2c-cb56-42e9-8e40-30df8551bb9e,.a9e28fa8-7fd5-48bd-8453-b7c400442eaf,.b994df03-6474-481b-a395-8d457f773b18,.bfe7afad-bd5a-4943-bec3-64d3247c5ffe{stroke:#6a0035;}.b994df03-6474-481b-a395-8d457f773b18,.fd94afec-1ba5-4319-998b-6c03797e77f3{stroke-width:13.47px;}.e32b99b4-94d3-4e11-8768-dd27a23284a3{fill:#331a20;}.b32f2af8-6703-4801-bfe8-d20cf8f3c6e8{fill:#ffc31a;}.a350f833-7759-4b3e-9474-ab610b732378{clip-path:url(#ae33d0c3-e191-489d-add7-388970f3ed4c);}.a4753a2c-cb56-42e9-8e40-30df8551bb9e,.b30a17df-5083-4e10-8579-04c3a27d8be0{stroke-width:14.13px;}.a2fd895f-d03b-4a20-9916-1ec3d6481010,.bfe7afad-bd5a-4943-bec3-64d3247c5ffe{stroke-width:16.78px;}.b30bc18e-5ffa-4a82-99a4-a3853cfdb785,.be2ae0c6-f57b-403e-9f6b-b9b3cc078884{fill:#bdd0fb;}.b30bc18e-5ffa-4a82-99a4-a3853cfdb785{mix-blend-mode:multiply;opacity:0.5;}.e4e4c283-90c2-4074-a155-584ddb2e334f{fill:url(#f905d3e8-b0eb-4dcc-85ce-651c226612b8);}.a47fc489-8831-4428-99b3-80072f132af4{fill:url(#bb25a793-e712-45f9-9d8e-c4050c163b92);}.b9882439-2e00-4722-8876-9b19722e6d7a{fill:url(#eee7805d-6864-437f-9f33-138b074ddd3e);}\n        "), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae33d0c3-e191-489d-add7-388970f3ed4c",
    transform: "translate(-165 151.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ae6a995f-2ac8-4537-ab97-01ab3415125e",
    "data-name": "mask_loop",
    className: "a0e2a570-2ce9-4eb9-b0c6-29d1bdb09fd1",
    cx: 792.45,
    cy: 480.15,
    r: 186.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f905d3e8-b0eb-4dcc-85ce-651c226612b8",
    x1: 341.88,
    y1: 585.6,
    x2: 458.26,
    y2: 872.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#faf6f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#dfc8d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c69db1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#b07793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9d577a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8d3b64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#802553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#761445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#6f093c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#6b0236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a0035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb25a793-e712-45f9-9d8e-c4050c163b92",
    x1: 659.78,
    y1: 249.79,
    x2: 872.27,
    y2: 617.84,
    xlinkHref: "#f905d3e8-b0eb-4dcc-85ce-651c226612b8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eee7805d-6864-437f-9f33-138b074ddd3e",
    x1: 624.51,
    y1: 318.07,
    x2: 917.17,
    y2: 601.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c1dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#93c7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6bb3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#4aa2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2f94ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#1a89ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#0b82ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#037dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007cff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a47359d0-2193-4871-8304-9bd8721d890f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bfc35abb-56e1-4a39-98db-f1cbba67d4df",
    "data-name": "tablet_base"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bdbc7b07-7a52-4d2c-b1c1-2c2834483b77",
    "data-name": "bg_t"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e3a0b4d1-f409-4018-ac4b-20e4d488304d",
    "data-name": "back_t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b8bf4240-1748-4086-9946-a50b16bf104a",
    "data-name": "base",
    className: "ae5cbfba-7d25-4345-92a6-7d275226ecc6",
    d: "M863.29,99.39h766.87c14.13,0,20.52,10.14,14,22.25L1154.91,1032.8c-6.07,11.31-21.22,20.2-34.42,20.2H353.62c-14.14,0-20.53-10.14-14-22.25L828.86,119.59C834.94,108.28,850.08,99.39,863.29,99.39Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b3962cb5-5cf1-43ad-b9d0-6e94e31b29ed",
    "data-name": "corn_bottom",
    className: "ae5cbfba-7d25-4345-92a6-7d275226ecc6",
    d: "M323,1028.37l19.09,21.38,35.17-3.08-30.77-25.93-22.1,3.68A2.39,2.39,0,0,0,323,1028.37Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "a1f2b609-1f22-47a1-b958-162f31c6abe9",
    "data-name": "corn_top",
    className: "ae5cbfba-7d25-4345-92a6-7d275226ecc6",
    points: "1468.12 234.22 1480.87 258.83 1457.72 281.98 1450.39 260 1468.12 234.22"
  })), /*#__PURE__*/React.createElement("path", {
    id: "aa46aff0-df58-4535-8b7c-45d89e0bb1de",
    "data-name": "front_t",
    className: "b956e935-0174-4c64-bce6-ab184e990bae",
    d: "M842.38,77.41h779.53c10.52,0,15.28,7.55,10.44,16.56l-495.09,922c-4.52,8.42-15.8,15-25.63,15H332.1c-10.52,0-15.28-7.54-10.44-16.56l495.09-922C821.27,84,832.55,77.41,842.38,77.41Z",
    transform: "translate(-165 151.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ba2780a5-32bf-4673-bb4e-8c5d7932c620",
    "data-name": "content"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f2ae88a7-399b-4baa-830a-8e36fac56311",
    "data-name": "shadow_paper",
    className: "a02a5973-6030-4987-bdf1-ad8922314aaa",
    d: "M865.45,149.77l654.7-18.85-398,830.42c-8.22,16-28.17,28.38-45.33,28l-501.69-16L466.27,896.76Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b45c7043-6769-49eb-bf9a-cdba68f4cb4b",
    "data-name": "paper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b363a60a-d1a4-40cf-a19c-990c54ddfa45",
    "data-name": "base_paper",
    className: "abe8dd8d-644b-41e6-b164-f6ae009d519f",
    d: "M859.4,137.38Q681.51,515.74,460.26,894.73q56.87,51.72,112.94,103.41l471.45.92c16.51,0,35.59-11.35,44.75-26.74q247.45-415.56,443.33-831.94c7.68-16.32-.36-29.84-17.68-29.87l-612.64-1.2C885.79,109.28,866.76,121.72,859.4,137.38Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f3598240-9368-4bf7-acde-2982fbe8d951",
    "data-name": "corn_shadow",
    className: "a02a5973-6030-4987-bdf1-ad8922314aaa",
    d: "M572.2,996.86l30-86.1a22.1,22.1,0,0,0-23.11-29.26L465.21,893.11Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd191941-0ada-4026-ba3c-cb49c65bf7a1",
    "data-name": "corn_paper",
    className: "f500324f-3e3e-4942-941a-72d0873443c2",
    d: "M460.26,894.73q56.87,51.72,112.94,103.41Q583,945.6,592,893c3-17.25-11.48-27.46-31.76-22.53Z",
    transform: "translate(-165 151.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b141e3ab-0792-4aa0-a730-ceb1620cacd1",
    "data-name": "content_paper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e476947f-ca70-4bc8-8795-19c07140cfd9",
    "data-name": "text_t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "afdd9949-6bc0-49f4-9add-d7fcd3a20626",
    "data-name": "line_t_1",
    className: "fad0a59a-6131-4d99-ba87-fe17e858aca0",
    d: "M1384.29,249.2l-336.58,2q6-10.12,11.93-20.23l336-1.88Q1389.94,239.15,1384.29,249.2Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e63de8a3-4338-44a8-aba5-552efe1689ad",
    "data-name": "line_t_2",
    className: "fad0a59a-6131-4d99-ba87-fe17e858aca0",
    d: "M1287.52,292.14,1022.73,294q5.93-10.2,11.87-20.37l264.31-1.71Q1293.21,282,1287.52,292.14Z",
    transform: "translate(-165 151.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bed5b6cc-9b53-4b17-8476-2a974e9a7f14",
    "data-name": "text_m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b1085397-b1df-4c5e-a9c9-9bf708ff8dc1",
    "data-name": "line_m_1",
    className: "fad0a59a-6131-4d99-ba87-fe17e858aca0",
    d: "M1041.06,503.42l-126.19,1.22q5.82-10.41,11.66-20.8l126-1.17Q1046.76,493,1041.06,503.42Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b57874cd-cdca-4c56-889a-1e9d27171e8e",
    "data-name": "line_m_2",
    className: "fad0a59a-6131-4d99-ba87-fe17e858aca0",
    d: "M1160,502.26l-92.29.9q5.67-10.38,11.38-20.74l92.12-.86Q1165.57,491.91,1160,502.26Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a467fd9b-595a-40b4-be41-4af8549d5f0b",
    "data-name": "line_m_3",
    className: "fad0a59a-6131-4d99-ba87-fe17e858aca0",
    d: "M1191.1,545.4l-300.64,3.2q5.77-10.49,11.59-20.94l300.09-3.07Q1196.61,535,1191.1,545.4Z",
    transform: "translate(-165 151.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ab582149-9554-4dae-9c07-b696e3f63a83",
    "data-name": "text_b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "be7cb733-b4f0-4e75-85c9-9cb390f26d1f",
    "data-name": "line_b_2",
    className: "fad0a59a-6131-4d99-ba87-fe17e858aca0",
    d: "M1116.43,775.54l-348.09,4.88Q762.69,791.18,757,802l348.73-5.05Q1111.09,786.22,1116.43,775.54Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bbf18fbe-ec67-44aa-9b59-7bd4fec5112b",
    "data-name": "line_b_1",
    className: "fad0a59a-6131-4d99-ba87-fe17e858aca0",
    d: "M1064,731.83,792.2,735.39q-5.7,10.68-11.37,21.38l272.27-3.68Q1058.52,742.44,1064,731.83Z",
    transform: "translate(-165 151.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b573f18f-b1ab-45f1-b955-7bf838e2f670",
    "data-name": "top"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a14f1f53-a288-4895-9bab-340c82a8b4a3",
    "data-name": "top_box",
    className: "f6cddd5a-87d8-4287-a3ea-32b7ed0198c1",
    d: "M954.21,299.82l-76.51-.16c-6.15,0-8.21-5.37-4.41-11.45l44-70.47c3.22-5.16,9.57-9,14.78-9l76.51.16c6.14,0,8.2,5.37,4.4,11.46L969,290.8C965.76,296,959.41,299.84,954.21,299.82Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "e98cd100-d3ac-4f91-856a-84a5f7c0e932",
    "data-name": "top_check",
    className: "a9e28fa8-7fd5-48bd-8453-b7c400442eaf",
    points: "752.21 401.37 765.11 427.42 864.39 375.59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "acd82b50-db4f-4dd4-941d-bbda8858c770",
    "data-name": "middle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b2e34903-035f-42be-8a36-004ec5a9c53d",
    "data-name": "middle_box",
    className: "fd94afec-1ba5-4319-998b-6c03797e77f3",
    d: "M824.67,569.73l-90.87-.19c-7.3,0-10.33-6.49-6.48-13.84l44.62-85.1c3.26-6.23,10.38-10.91,16.57-10.9l90.87.19c7.3,0,10.33,6.49,6.48,13.84l-44.61,85.1C838,565.06,830.86,569.74,824.67,569.73Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "a99d8dee-10dd-40bf-b91a-bc414a3d9767",
    "data-name": "middle_check",
    className: "b994df03-6474-481b-a395-8d457f773b18",
    points: "610.38 661 628.52 692.45 740.8 629.85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b1dd52dc-b94b-4aff-b21b-19bf5f4de51d",
    "data-name": "bottom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fbf2354e-1c2d-4bbf-8234-869386812a2f",
    "data-name": "bottom_box",
    className: "f6cddd5a-87d8-4287-a3ea-32b7ed0198c1",
    d: "M697.1,808.23l-76.51-.16c-6.15,0-8.21-5.38-4.41-11.46l44-70.47c3.22-5.16,9.57-9,14.78-9l76.51.16c6.14,0,8.2,5.38,4.4,11.46l-44,70.47C708.66,804.36,702.3,808.24,697.1,808.23Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "aeed3b2b-9804-43d9-b448-208358414194",
    "data-name": "bottom_check",
    className: "a9e28fa8-7fd5-48bd-8453-b7c400442eaf",
    points: "495.1 909.77 508 935.82 607.28 883.99"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "f9e01dac-77f6-4c85-b69f-c7ccf8a52fec",
    "data-name": "bg_f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a24bec90-e569-447a-8944-b9648c997d9b",
    "data-name": "bg_f_1",
    className: "e32b99b4-94d3-4e11-8768-dd27a23284a3",
    d: "M1021.23,101c21.61-27.22,55.67-45.27,85.45-45.27h60.61c9,0,19.2-4.74,25.35-12C1207.33,26.37,1231.9,14,1254.78,14s37.27,12.37,37.69,29.73c.17,7.27,6.42,12,15.46,12h60.61c29.78,0,49,18.05,48.22,45.27l-.31,10.88H1012.6Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b197aefd-33d2-40d6-8829-0740c91d187d",
    "data-name": "bg_f_2",
    className: "b32f2af8-6703-4801-bfe8-d20cf8f3c6e8",
    d: "M1010.06,122.56h397.47c6.84,0,15-4.8,18.18-10.67h0c3.15-5.88.13-10.68-6.72-10.68H1021.52c-6.84,0-15,4.8-18.18,10.68h0C1000.19,117.76,1003.21,122.56,1010.06,122.56Z",
    transform: "translate(-165 151.06)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "f9b3fca4-cca4-4a5d-a59c-babfe1e3b26e",
    "data-name": "mignifying_mirror"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e3683edc-5377-406f-997c-6dab5e586a27",
    "data-name": "mask"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a350f833-7759-4b3e-9474-ab610b732378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f1dfca3c-6fbd-4a94-a5f4-cc85935877d1",
    "data-name": "tablet_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b03a73ed-a196-457d-af00-33126ce9bc07",
    "data-name": "bg_t_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b278e337-96b3-45d0-9b87-96b324005213",
    "data-name": "back_t_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b75a4227-2898-46c0-84bb-2574d9ff01d0",
    "data-name": "base_1",
    className: "ae5cbfba-7d25-4345-92a6-7d275226ecc6",
    d: "M842.07-44.69h955.29c17.6,0,25.56,12.63,17.46,27.72l-609.48,1135c-7.56,14.08-26.43,25.15-42.88,25.15H207.17c-17.6,0-25.56-12.62-17.46-27.71l609.48-1135C806.75-33.61,825.62-44.69,842.07-44.69Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a9fd83cb-c1f2-4f84-b69e-5b5fa0577f3e",
    "data-name": "corn_bottom_1",
    className: "ae5cbfba-7d25-4345-92a6-7d275226ecc6",
    d: "M169.08,1112.54l23.79,26.64,43.8-3.84L198.34,1103l-27.53,4.59A3,3,0,0,0,169.08,1112.54Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "f7b9166d-2913-49ff-b1cb-a789738614d4",
    "data-name": "corn_top_1",
    className: "ae5cbfba-7d25-4345-92a6-7d275226ecc6",
    points: "1636.05 86.15 1651.93 116.81 1623.09 145.65 1613.97 118.27 1636.05 86.15"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a7e02320-1a59-44d3-bc5f-10429c76448d",
    "data-name": "front_t_1",
    className: "b956e935-0174-4c64-bce6-ab184e990bae",
    d: "M816-72.06h971.07c13.1,0,19,9.4,13,20.62L1183.35,1097.12c-5.63,10.49-19.68,18.73-31.92,18.73H180.37c-13.11,0-19-9.4-13-20.63L784.1-53.34C789.73-63.82,803.78-72.06,816-72.06Z",
    transform: "translate(-165 151.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ad9fad3f-6a88-4c8c-b929-7855f7d73a4f",
    "data-name": "content_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a1f4f193-b588-4b14-a490-0c8afeb34e3b",
    "data-name": "shadow_paper_1",
    className: "a02a5973-6030-4987-bdf1-ad8922314aaa",
    d: "M844.76,18.07,1660.33-5.41,1164.5,1029c-10.25,20-35.09,35.35-56.47,34.94l-625-19.9L347.51,948.59Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bb112c85-2f98-44d7-8943-a1592b54c853",
    "data-name": "paper_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a1af35cc-18c1-44c5-acce-166155644b41",
    "data-name": "base_paper_1",
    className: "abe8dd8d-644b-41e6-b164-f6ae009d519f",
    d: "M837.22,2.64Q615.64,474,340,946.07q70.85,64.42,140.7,128.82L1068,1076c20.57,0,44.33-14.13,55.75-33.31Q1432,525.07,1676,6.37c9.56-20.33-.45-37.17-22-37.21L890.81-32.33C870.1-32.37,846.4-16.88,837.22,2.64Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b9754b44-d188-4c18-8e51-c3b8d87e18eb",
    "data-name": "corn_shadow_1",
    className: "a02a5973-6030-4987-bdf1-ad8922314aaa",
    d: "M479.46,1073.29,516.84,966a27.53,27.53,0,0,0-28.79-36.44L346.18,944.05Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e101d49d-151d-4c3a-9ca4-daae58c125c3",
    "data-name": "corn_paper_1",
    className: "f500324f-3e3e-4942-941a-72d0873443c2",
    d: "M340,946.07q70.85,64.42,140.7,128.82,12.24-65.46,23.45-131c3.68-21.48-14.3-34.2-39.56-28.07Q402.33,931,340,946.07Z",
    transform: "translate(-165 151.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "af693312-d998-461c-900a-45b053247441",
    "data-name": "content_paper_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b8fe2f76-5f38-431a-bd8c-93b36f618db1",
    "data-name": "text_t_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b1e5e0e6-333c-485b-acab-c0cb3777c8e8",
    "data-name": "line_t_1_1",
    className: "fad0a59a-6131-4d99-ba87-fe17e858aca0",
    d: "M1491.09,141.93l-419.28,2.52q7.41-12.62,14.86-25.2l418.52-2.34Q1498.13,129.41,1491.09,141.93Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f9feb003-3cac-4471-8047-fb7e767b2ac0",
    "data-name": "line_t_2_1",
    className: "fad0a59a-6131-4d99-ba87-fe17e858aca0",
    d: "M1370.54,195.43l-329.85,2.27q7.36-12.69,14.78-25.37l329.25-2.13Q1377.63,182.8,1370.54,195.43Z",
    transform: "translate(-165 151.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a48620f0-73f9-4eee-acb0-0a77ee8668b8",
    "data-name": "text_m_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ec5bc33d-3451-4098-a84a-f59654ea5ccf",
    "data-name": "line_m_1_1",
    className: "fad0a59a-6131-4d99-ba87-fe17e858aca0",
    d: "M1063.51,458.61l-157.19,1.53q7.24-13,14.53-25.92l156.9-1.46Q1070.63,445.68,1063.51,458.61Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc65758e-f378-49d0-a78c-875470aa2967",
    "data-name": "line_m_2_1",
    className: "fad0a59a-6131-4d99-ba87-fe17e858aca0",
    d: "M1211.65,457.17l-115,1.11q7.07-12.91,14.17-25.83l114.76-1.06Q1218.62,444.26,1211.65,457.17Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be045c50-d884-4734-8af7-5ed2f4d9d855",
    "data-name": "line_m_3_1",
    className: "fad0a59a-6131-4d99-ba87-fe17e858aca0",
    d: "M1250.42,510.91l-374.51,4q7.22-13,14.44-26.09L1264.18,485Q1257.28,497.94,1250.42,510.91Z",
    transform: "translate(-165 151.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ac4ab99e-4ad4-4c8f-8092-27820656da83",
    "data-name": "text_b_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a85a59e2-8a1f-4628-b405-3afc346608d6",
    "data-name": "line_b_2_1",
    className: "fad0a59a-6131-4d99-ba87-fe17e858aca0",
    d: "M1157.41,797.59l-433.62,6.09q-7,13.4-14.07,26.81l434.41-6.29Q1150.76,810.9,1157.41,797.59Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aba7cbf9-bc12-4a61-bb7d-54c72530ca28",
    "data-name": "line_b_1_1",
    className: "fad0a59a-6131-4d99-ba87-fe17e858aca0",
    d: "M1092.06,743.14l-338.54,4.44q-7.1,13.29-14.17,26.63l339.16-4.59Q1085.28,756.38,1092.06,743.14Z",
    transform: "translate(-165 151.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f880858a-0aed-438e-8838-4a65ce64457e",
    "data-name": "top_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a6913ce4-cd46-4e31-bc44-9b467294a556",
    "data-name": "top_box_1",
    className: "b30a17df-5083-4e10-8579-04c3a27d8be0",
    d: "M955.33,205l-95.31-.2c-7.66,0-10.23-6.69-5.49-14.27l54.8-87.78c4-6.43,11.92-11.26,18.4-11.25l95.31.2c7.66,0,10.23,6.7,5.49,14.28l-54.79,87.78C969.72,200.17,961.81,205,955.33,205Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "ff70a7e0-9da9-4097-9a6b-9fd922ac6d71",
    "data-name": "top_check_1",
    className: "a4753a2c-cb56-42e9-8e40-30df8551bb9e",
    points: "744.24 294.37 760.31 326.82 883.98 262.25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e376de66-30c6-428b-b806-0fe0d044458f",
    "data-name": "middle_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a88bfd24-a099-4cae-a3a9-08bf50b7488e",
    "data-name": "middle_box_1",
    className: "a2fd895f-d03b-4a20-9916-1ec3d6481010",
    d: "M794,541.22,680.76,541c-9.09,0-12.86-8.08-8.06-17.24l55.57-106c4.07-7.76,12.94-13.6,20.65-13.58l113.2.24c9.09,0,12.86,8.08,8.06,17.23l-55.57,106C810.54,535.4,801.67,541.23,794,541.22Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "eefd44ec-0fea-42ee-9858-8c6b63421f68",
    "data-name": "middle_check_1",
    className: "bfe7afad-bd5a-4943-bec3-64d3247c5ffe",
    points: "567.57 617.79 590.16 656.97 730.03 579"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b1c88d06-7e35-49cf-8e69-ef3d119634ee",
    "data-name": "bottom_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a566c88d-6370-4588-b32f-f7bf87825377",
    "data-name": "bottom_box_1",
    className: "b30a17df-5083-4e10-8579-04c3a27d8be0",
    d: "M635,838.31l-95.3-.2c-7.66,0-10.23-6.69-5.49-14.27L589,736.05c4-6.42,11.93-11.25,18.41-11.24l95.31.2c7.66,0,10.22,6.69,5.49,14.27l-54.8,87.79C649.44,833.49,641.53,838.32,635,838.31Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "b3c94795-17bf-41a9-be8d-8e5c89ec2361",
    "data-name": "bottom_check_1",
    className: "a4753a2c-cb56-42e9-8e40-30df8551bb9e",
    points: "423.96 927.69 440.03 960.13 563.7 895.57"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ea5b6a01-2b49-4fd5-a10b-0cdf6ea564c2",
    "data-name": "bg_f_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a54b657b-8d1d-44a4-917f-1f872d26fbdb",
    "data-name": "bg_f_1_1",
    className: "e32b99b4-94d3-4e11-8768-dd27a23284a3",
    d: "M1038.82-42.67c26.91-33.91,69.35-56.39,106.44-56.39h75.5c11.27,0,23.92-5.91,31.58-15,18.3-21.62,48.91-37,77.41-37s46.43,15.41,47,37c.21,9.06,8,15,19.26,15h75.51c37.09,0,61,22.48,60.06,56.39l-.39,13.55H1028.06Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "abf3ce1c-1879-46e9-a4b0-a27ddd689d77",
    "data-name": "bg_f_2_1",
    className: "b32f2af8-6703-4801-bfe8-d20cf8f3c6e8",
    d: "M1024.9-15.82H1520c8.53,0,18.72-6,22.64-13.3h0c3.93-7.32.17-13.3-8.36-13.3H1039.18c-8.53,0-18.72,6-22.64,13.3h0C1012.61-21.81,1016.37-15.82,1024.9-15.82Z",
    transform: "translate(-165 151.06)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "b0f017e2-f10a-4490-9b52-c448161ef387",
    "data-name": "loop"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "bee29953-06b3-4f81-a7b3-b3850cac11e6",
    "data-name": "gray",
    className: "be2ae0c6-f57b-403e-9f6b-b9b3cc078884",
    points: "311.54 762.64 330.32 799.76 465.51 730.54 446.73 693.41 311.54 762.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "a3913531-8ebd-42cd-8f60-8cd4ec6343de",
    "data-name": "shadow_loop",
    className: "b30bc18e-5ffa-4a82-99a4-a3853cfdb785",
    points: "456.12 711.98 446.73 693.41 311.54 762.64 320.93 781.2 456.12 711.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fe9ed338-6431-4ff6-80e8-7c736647285d",
    "data-name": "handle",
    className: "e4e4c283-90c2-4074-a155-584ddb2e334f",
    d: "M249.07,707.13c-19.6,9.9-27.79,33.16-18.29,51.94h0c9.49,18.78,33.09,26,52.69,16.07l230.3-116.37c19.61-9.91,27.8-33.16,18.3-51.94h0c-9.49-18.78-33.09-26-52.7-16.07Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a61a4546-e4f5-4b2e-bfd9-83bf48976167",
    "data-name": "big_cirlce",
    className: "a47fc489-8831-4428-99b3-80072f132af4",
    d: "M694.63,286.65c-109.32,55.24-155,184.9-102,289.6s184.5,144.8,293.82,89.56,155-184.89,102-289.59S803.94,231.42,694.63,286.65ZM954.89,393.18c44,86.95,6,194.63-84.74,240.5s-200,12.56-244-74.39-6-194.63,84.73-240.5S910.91,306.22,954.89,393.18Z",
    transform: "translate(-165 151.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b8235f47-3c4f-4296-bb20-640a6b01ed5d",
    "data-name": "small_circle",
    className: "b9882439-2e00-4722-8876-9b19722e6d7a",
    d: "M701.59,302.71c-101.32,51.42-143.74,172-94.75,269.22S777.69,706.38,879,655,1022.76,483,973.76,385.75,802.91,251.3,701.59,302.71ZM948.83,398.4C991.16,482.46,954.51,586.61,867,631s-192.85,12.3-235.18-71.75-5.69-188.21,81.87-232.63S906.49,314.35,948.83,398.4Z",
    transform: "translate(-165 151.06)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliance);
export default __webpack_public_path__ + "static/media/compliance.4212e4de32cf9e93713dc49a79dbf2e3.svg";
export { ForwardRef as ReactComponent };